import {D3ChartRenderable, D3ChartSize, D3GSelection, D3SvgSelection} from "./D3Chart";
import * as d3Scale from "d3-scale";

export class D3ChartText implements D3ChartRenderable {

    private g: D3GSelection | undefined;

    constructor(public scaleX: d3Scale.ScaleLinear<number, number, never>,
                public scaleY: d3Scale.ScaleLinear<number, number, never>,
                public x: number,
                public y: number,
                public text: string,
                public offsetX: number = 4,
                public offsetY: number = -5,
                public fontSize: string = "12px",
                public fill: string = "black") {
    }

    initialize(svgSelection: D3SvgSelection, rootG: D3GSelection, unClippedRootG: D3GSelection, size: D3ChartSize): void {
        this.g = rootG.append("g");
        this.g.append("text");
    }

    render(): void {
        this.g?.select("text")
            .attr("x", this.scaleX(this.x) + this.offsetX)
            .attr("y", this.scaleY(this.y) + this.offsetY)
            .attr("font-size", this.fontSize)
            .attr("fill", this.fill)
            .style("text-anchor", "start")
            .text(this.text);
    }
}